import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { MemberAppDataService } from "../services";
import { MemberType } from "../../shared/enums/data.enums";

@Injectable({
  providedIn: 'root'
})
export class ChaptersGuard implements CanActivate {
  constructor(
    private router: Router,
    private memberAppDataService: MemberAppDataService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    let p = this.memberAppDataService.memberAppData ? this.memberAppDataService.memberAppData.profile : null;

    if (p && p.IsInternational) {
      this.memberAppDataService.navigateToRoute("sections");
      return false;
    }
    return true;
  }
}
